/** MAX messenger skin (inspired by web.max.ru). */
import { MessengerWorkspace } from "../MessengerWorkspace";

export function MaxShell() {
  return <MessengerWorkspace kind="max" themeClass="theme-max" brand="MAX" />;
}
